module.exports = __webpack_public_path__ + "img/24_19.6094cb45.png";